<template>
    <div>
        <div class="d-flex justify-content-center mb-3">
            <ul class="nav nav-pills">
                <li class="nav-item">
                    <a class="nav-link" href="#" :class="aba == 'pacientes' ? 'active' : ''" @click.prevent="abrir('pacientes')">
                        Pacientes
                    </a>
                </li>
            </ul>
        </div>

        <nutricao-pacientes v-if="aba == 'pacientes'"></nutricao-pacientes>

        

    </div>
</template>

<script>
import NutricaoPacientes from './NutricaoPacientes.vue';

export default {
    data() {
        return {
            dados: null,
            parms: null,
        };
    },

    props: ['aba'],

    components: {
        NutricaoPacientes,
    },

    methods: {
        abrir(aba) {
            if ( aba != this.aba ) {
                this.$router.push({ path: '/nutricao/' + aba });
            }
        },
    }
}
</script>
